import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { AxiosCustomGet } from "../../../components/axios/AxiosCustom";
import Config from "../../../components/axios/Config";
import SwalToast from "../../../components/helpers/SwalToast";
import httpclient from "../../../components/httpclient";
import Title from "../../../components/common/Title/Title";
import IsEmpty from "../../../components/helpers/IsEmpty";
import { Modal, Button, Input } from "antd";
import "antd/dist/antd.css";
import "./styles.css";
import CustomTable from "../../../components/common/Table/CustomTable";
import { dataBreadcrumb, productsListFilter, renderColumns } from "./constants";
import { TiUser } from "react-icons/ti";
import AppRoutePath from "../../../router/AppRoutePath";
import { useHistory, useParams } from "react-router-dom";
import CustomBreadcrumb from "../../../components/common/Breadcrumb/CustomBreadcrumb";
import TextInput from "../../../components/common/TextInput/TextInput";
import { convertProduct } from "./helpers/convertProducts";
import { convertUrl } from "./helpers/convertUrl";
import NumberFormat from "react-number-format";
import ErrorDiv from "../../../components/helpers/ErrorDiv";
import {
  AuthorizationList,
  CanAccess,
} from "../../../components/template/authorization/Authorization";
import Swal from "sweetalert2";
import { FaInfoCircle } from "react-icons/fa";

const ListProducts = () => {
  const [id, setId] = useState();
  const [minPrice, setMinPrice] = useState();
  const [maxPrice, setMaxPrice] = useState();
  const [brand, setBrand] = useState();
  const [model, setModel] = useState();
  const [type, setType] = useState();
  const [year, setYear] = useState();
  const [records, setRecords] = useState([]);
  const [search, setSearch] = useState("");
  const [modalAdd, setModalAdd] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tablePagination, setTablePagination] = useState({});
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const history = useHistory();
  const [pageSizeValue, setPageSizeValue] = useState(10);
  const [filterInput, setFilterInput] = useState(productsListFilter);
  const [errors, setErrors] = useState({});
  const [totalRecord, setTotalRecord] = useState(0);
  let { code_product } = useParams();

  useEffect(() => {
    getData();
  }, [filterInput]);

  const validate = () => {
    const newErrors = {};

    if (IsEmpty(brand)) {
      newErrors.brand = "Merk tidak boleh kosong";
    }
    if (IsEmpty(model)) {
      newErrors.model = "Model tidak boleh kosong";
    }
    if (IsEmpty(maxPrice) && maxPrice !== 0) {
      newErrors.maxPrice = "Harga maksimal tidak boleh kosong";
    }
    if (IsEmpty(minPrice) && minPrice !== 0) {
      newErrors.minPrice = "Harga minimal tidak boleh kosong";
    }
    if (code_product == 2 || code_product == 3) {
      if (IsEmpty(type)) {
        newErrors.type = "Tipe tidak boleh kosong";
      }
      if (IsEmpty(year)) {
        newErrors.year = "Tahun tidak boleh kosong";
      }
    }
    return newErrors;
  };

  const handleSubmit = (isDelete = false) => {
    const newErrors = validate();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    } else {
      let data = {
        id: id,
        brand: brand,
        model: model,
        min_price: minPrice,
        max_price: maxPrice,
        type: type,
        year: parseInt(year),
      };
      console.log(data);
      setSubmitting(true);

      let url = convertUrl(code_product);
      if (IsEmpty(id)) {
        httpclient
          .POST(url, data)
          .then((response) => {
            console.log(response);
            SwalToast.fire({
              icon: "success",
              title: response.data.message,
            });
            getData();
            setModalAdd(false);
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response.data.error);
              SwalToast.fire({
                icon: "error",
                title:
                  error.response.data.error?.message ||
                  "Whoops, something went wrong",
              });
            } else {
              console.log(error);
              SwalToast.fire({
                icon: "error",
                title: "Whoops, something went wrong",
              });
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      } else {
        if (isDelete === true) {
          httpclient
            .DELETE(
              `${process.env.REACT_APP_BASE_API_URL}product-category/${id}`
            )
            .then((response) => {
              SwalToast.fire({
                icon: "success",
                title: response.data.message,
              });
              getData();
            })
            .catch((error) => {
              if (error.response) {
                console.log(error.response.data.error);
                SwalToast.fire({
                  icon: "error",
                  title:
                    error.response.data.error?.message ||
                    "Whoops, something went wrong",
                });
              } else {
                console.log(error);
                SwalToast.fire({
                  icon: "error",
                  title: "Whoops, something went wrong",
                });
              }
            })
            .finally(() => {
              setSubmitting(false);
            });
        } else {
          httpclient
            .PUT(url, data)
            .then((response) => {
              SwalToast.fire({
                icon: "success",
                title: response.data.message,
              });
              getData();
              setModalAdd(false);
            })
            .catch((error) => {
              if (error.response) {
                console.log(error.response.data.error);
                SwalToast.fire({
                  icon: "error",
                  title:
                    error.response.data.error?.message ||
                    "Whoops, something went wrong",
                });
              } else {
                console.log(error);
                SwalToast.fire({
                  icon: "error",
                  title: "Whoops, something went wrong",
                });
              }
            })
            .finally(() => {
              setSubmitting(false);
            });
        }
      }
    }
  };

  const handleEdit = (record) => {
    setBrand(record.brand);
    setMinPrice(record.minPriceNumber);
    setMaxPrice(record.maxPriceNumber);
    setModel(record.model);
    setYear(record.year);
    setType(record.type);
    setId(record.id);
    setModalAdd(true);
    setIsEdit(true);
  };

  const handleDelete = (record) => {
    setSubmitting(true);
    let url = `${process.env.REACT_APP_BASE_API_URL}product-category/${code_product}/products/${record.id}`;
    console.log(url);
    Swal.fire({
      title: "Hapus Data",
      text:
        "Apakah anda yakin ingin menghapus produk " +
        record.brand +
        " " +
        record.model,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Hapus",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        httpclient
          .DELETE(url)
          .then((response) => {
            SwalToast.fire({
              icon: "success",
              title: response.data.message,
            });
            getData();
            setSubmitting(false);
          })
          .catch((error) => {
            console.log(error);
            if (error.response) {
              SwalToast.fire({
                icon: "error",
                title: error.response.data.error.message,
              });
            } else {
              SwalToast.fire({
                icon: "error",
                title: "Whoops, something went wrong",
              });
              setSubmitting(false);
            }
          });
      }
    });
  };

  const handleCloseModal = () => {
    setModalAdd(false);
    setBrand("");
    setModel("");
    setMinPrice("");
    setMaxPrice("");
    setId("");
    setErrors({});
  };

  const getData = () => {
    let params = {
      search: filterInput.search,
      page: filterInput.page,
      size: parseInt(filterInput.pageSize),
    };
    setLoading(true);
    let url = convertUrl(code_product);
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        params
      ),
      (response) => {
        const data = response?.data?.data;
        setLoading(false);
        setRecords(convertProduct(code_product, data.items));
        setTotalRecord(data?.total_item);
        setTablePagination({
          current: data?.page,
          pageSize: data?.per_page,
          total: data?.total_item,
        });
      },
      (error) => {
        setLoading(false);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const searchData = (name) => {
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    setSearch(name);
    setSearchTimeout(
      setTimeout(function () {
        getData();
      }, 700)
    );
  };

  const handleEnter =
    (type = "enter") =>
    (event) => {
      const { name, value } = event.target;
      if (event.keyCode === 13 || type === "blur") {
        if (name === "pageSize" && value === "") {
          setPageSizeValue(10);
        }
        setFilterInput((prev) => ({
          ...prev,
          [name]: name === "pageSize" && value === "" ? 10 : value,
          page: 1,
        }));
      }
    };

  const handleTextInputChange = (event) => {
    const { name, value } = event.target;
    if (name === "pageSize") {
      setPageSizeValue(value);
    } else if (name === "search") {
      setSearch(value);
    }
  };

  const handleTableChange = (pagination) => {
    setFilterInput((prev) => ({
      ...prev,
      page: pagination.current,
      size: parseInt(pagination.pageSize),
    }));
  };

  const onUploadButton = () => {
    history.push({
      pathname: `upload-product/${code_product}`,
    });
  };

  const onDeleteAll = () => {
    setSubmitting(true);
    Swal.fire({
      title: "Hapus Data",
      text: "Apakah anda yakin ingin menghapus semua produk?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Hapus",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        httpclient
          .DELETE(convertUrl(code_product))
          .then((response) => {
            SwalToast.fire({
              icon: "success",
              title: response.data.message,
            });
            getData();
            setSubmitting(false);
          })
          .catch((error) => {
            console.log(error);
            if (error.response) {
              SwalToast.fire({
                icon: "error",
                title: error.response.data.error.message,
              });
            } else {
              SwalToast.fire({
                icon: "error",
                title: "Whoops, something went wrong",
              });
              setSubmitting(false);
            }
          });
      }
    });
  };

  return (
    <>
      <div>
        <div className="px-3">
          <div
            className="py-4 d-flex justify-content-between"
            style={{ fontSize: "13px" }}
          >
            <div className="">
              <Title text={"Daftar Produk"} />
              <CustomBreadcrumb current={dataBreadcrumb} />
            </div>
            <div
              style={{
                padding: 13,
                border: "1px solid #DCDCDC",
                borderRadius: 5,
                height: 50,
                width: 222,
              }}
            >
              <div
                style={{
                  fontSize: 18,
                  color: "#303030",
                }}
              >
                <TiUser
                  style={{ marginBottom: 5, fontSize: 24, color: "#D6D6D6" }}
                />
                <span style={{ fontWeight: 700 }}>{totalRecord}</span> Total
                Produk
              </div>
            </div>
          </div>
          <div className="d-flex pt-3 align-items-center">
            <div className="d-flex filter-bar-2 align-items-end">
              <TextInput
                id={"pageSize"}
                label={"Tampilkan"}
                width={"20%"}
                handleEnter={handleEnter}
                handleChange={handleTextInputChange}
                value={pageSizeValue}
              />
              <TextInput
                id={"search"}
                label={"Nama Produk"}
                width={"80%"}
                placeholder={"Nama Produk"}
                handleEnter={handleEnter}
                handleChange={handleTextInputChange}
                value={search}
              />
            </div>

            <CanAccess
              role={AuthorizationList.create_product}
              yes={
                <div className="ml-auto">
                  <div className="ml-auto d-flex">
                    <div className="ml-auto" onClick={onDeleteAll}>
                      <Button
                        className="ml-3 btn text-white font-weight-semi-bold"
                        style={{ backgroundColor: "#F23434", width: 180 }}
                      >
                        Hapus Semua
                      </Button>
                    </div>
                    <div className="ml-auto" onClick={onUploadButton}>
                      <Button
                        className="ml-3 btn text-white font-weight-semi-bold"
                        style={{ backgroundColor: "#F5CB58", width: 180 }}
                      >
                        Upload Produk
                      </Button>
                    </div>
                    <div
                      className="ml-auto"
                      onClick={() => {
                        setModalAdd(true);
                        setIsEdit(false);
                      }}
                    >
                      <Button className="ml-3 btn bgc-2C465C text-white font-weight-semi-bold">
                        + Tambah Produk
                      </Button>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end">
                    <div
                      className="d-flex justify-content-center mt-2 align-items-center"
                      style={{
                        backgroundColor: "rgba(242, 52, 52, 0.3)",
                        borderRadius: 5,
                        padding: "9px 12px",
                      }}
                    >
                      <FaInfoCircle size={20} color="#F23434" />
                      <div style={{ fontSize: 12, marginLeft: 5 }}>
                        Hapus semua data yang ada sebelum upload data produk
                        baru
                      </div>
                    </div>
                  </div>
                </div>
              }
            />
          </div>
          <div style={{ marginTop: 24 }}>
            <CustomTable
              columns={renderColumns(handleEdit, handleDelete, code_product)}
              data={records}
              loading={loading}
              handleTableChange={handleTableChange}
              pagination={tablePagination}
            />
          </div>
        </div>
      </div>

      <Modal
        className="modal-add"
        centered
        title={`${isEdit ? "Ubah" : "Tambah"} Produk`}
        visible={modalAdd}
        onOk={handleSubmit}
        onCancel={handleCloseModal}
        footer={[
          <Button
            onClick={handleCloseModal}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 36,
              color: "#000",
              background: "#FFFFFF",
            }}
          >
            Kembali
          </Button>,
          <Button
            type="submit"
            disabled={submitting}
            onClick={handleSubmit}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 36,
              color: "#fff",
              background: "#2C465C",
            }}
          >
            Simpan
          </Button>,
        ]}
      >
        <div className="d-flex align-items-center my-3">
          <div style={{ flex: 1 }}>
            <div style={{ color: "#A6A6A6" }}>Merk :</div>
          </div>
          <div style={{ flex: 2 }}>
            <Input
              style={{ height: 36 }}
              required
              type="text"
              className="form-control border-DCDCDC text-input"
              placeholder="Merk"
              value={brand}
              onChange={(e) => setBrand(e.target.value)}
            />
            <ErrorDiv error={errors?.brand} />
          </div>
        </div>
        {code_product == 3 && (
          <div className="d-flex align-items-center my-3">
            <div style={{ flex: 1 }}>
              <div style={{ color: "#A6A6A6" }}>Tipe :</div>
            </div>
            <div style={{ flex: 2 }}>
              <Input
                style={{ height: 36 }}
                required
                type="text"
                className="form-control border-DCDCDC text-input"
                placeholder="Tipe"
                value={type}
                onChange={(e) => setType(e.target.value)}
              />
              <ErrorDiv error={errors?.type} />
            </div>
          </div>
        )}
        <div className="d-flex align-items-center my-3">
          <div style={{ flex: 1 }}>
            <div style={{ color: "#A6A6A6" }}>Model :</div>
          </div>
          <div style={{ flex: 2 }}>
            <Input
              style={{ height: 36 }}
              required
              type="text"
              className="form-control border-DCDCDC text-input"
              placeholder="Model"
              value={model}
              onChange={(e) => setModel(e.target.value)}
            />
            <ErrorDiv error={errors?.model} />
          </div>
        </div>
        {(code_product == 2 || code_product == 3) && (
          <>
            {code_product == 2 && (
              <div className="d-flex align-items-center my-3">
                <div style={{ flex: 1 }}>
                  <div style={{ color: "#A6A6A6" }}>Tipe :</div>
                </div>
                <div style={{ flex: 2 }}>
                  <Input
                    style={{ height: 36 }}
                    required
                    type="text"
                    className="form-control border-DCDCDC text-input"
                    placeholder="Tipe"
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                  />
                  <ErrorDiv error={errors?.type} />
                </div>
              </div>
            )}
            <div className="d-flex align-items-center my-3">
              <div style={{ flex: 1 }}>
                <div style={{ color: "#A6A6A6" }}>Tahun :</div>
              </div>
              <div style={{ flex: 2 }}>
                <Input
                  style={{ height: 36 }}
                  required
                  type="text"
                  className="form-control border-DCDCDC text-input"
                  placeholder="Tahun"
                  value={year}
                  onChange={(e) => setYear(e.target.value)}
                />
                <ErrorDiv error={errors?.year} />
              </div>
            </div>
          </>
        )}
        <div className="d-flex align-items-center my-3">
          <div style={{ flex: 1 }}>
            <div className="color-A6A6A6">Harga Minimal :</div>
          </div>
          <div style={{ flex: 2 }}>
            <div className="d-flex align-items-center">
              <NumberFormat
                className="form-control border-DCDCDC text-input"
                isNumericString={true}
                value={minPrice}
                onValueChange={(e) => setMinPrice(e.floatValue)}
                thousandSeparator={"."}
                decimalSeparator={","}
                style={{
                  marginRight: 5,
                  border: "0.75px solid #DCDCDC",
                  width: "100%",
                  paddingLeft: 6,
                  height: 36,
                  borderRadius: 5,
                  flex: 1,
                }}
              />
              <div className="color-A6A6A6 ml-1" style={{ flex: 0.2 }}>
                Rupiah
              </div>
            </div>
            <ErrorDiv error={errors?.minPrice} />
          </div>
        </div>
        <div className="d-flex align-items-center my-3">
          <div style={{ flex: 1 }}>
            <div className="color-A6A6A6">Harga Maksimal :</div>
          </div>

          <div style={{ flex: 2 }}>
            <div className="d-flex align-items-center">
              <NumberFormat
                className="form-control border-DCDCDC text-input"
                isNumericString={true}
                value={maxPrice}
                onValueChange={(e) => setMaxPrice(e.floatValue)}
                thousandSeparator={"."}
                decimalSeparator={","}
                style={{
                  marginRight: 5,
                  border: "0.75px solid #DCDCDC",
                  width: "100%",
                  paddingLeft: 6,
                  height: 36,
                  borderRadius: 5,
                  flex: 1,
                }}
              />
              <div className="color-A6A6A6 ml-1" style={{ flex: 0.2 }}>
                Rupiah
              </div>
            </div>
            <ErrorDiv error={errors?.maxPrice} />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ListProducts;
